import parse from 'date-fns/parse';
import useHostProfiles from 'modules/host/hooks/useHostProfiles';
import React from 'react';
import OtherLocalsSuccessSection from 'reusable-components/forms/ContactHostForm/OtherLocalsSuccessSection/OtherLocalsSuccessSection';
import useAvailableHostsForAreaByDuration from 'reusable-components/forms/ContactHostForm/RequestPersonalizedOfferForm/hooks/useAvailableHostsByDuration';
import { CONTACT_HOST_SOURCES } from '~/constants';

interface OtherLocalsSuccessByDurationSectionContainerProps {
  date: string;
  time: string;
  area: string;
  duration: number;
  source: CONTACT_HOST_SOURCES;
}

function OtherLocalsSuccessByDurationSectionContainer({
  date,
  area,
  duration,
  time,
  source,
}: OtherLocalsSuccessByDurationSectionContainerProps) {
  const { availableHostIds, isLoading: availableHostsLoading } =
    useAvailableHostsForAreaByDuration({
      area,
      duration,
      date: parse(date, 'yyyy-MM-dd', new Date()),
      time,
      nrOfHostsToReturn: 3,
    });
  const hosts = useHostProfiles(availableHostIds);
  if (availableHostsLoading || availableHostIds.length === 0) {
    return null;
  }

  const images =
    hosts.data
      ?.filter((host) => availableHostIds.includes(host.id))
      .map((host) => host.profilePicture) || [];

  return (
    <OtherLocalsSuccessSection
      images={images}
      availableHosts={availableHostIds}
      source={source}
    />
  );
}

export default OtherLocalsSuccessByDurationSectionContainer;
